import React from 'react';
import { bonuses } from '../data/content';
export function Bonuses() {
  return <section className="bg-navy-deep px-3 py-4 sm:px-6" data-id="element-18" data-mp="pjpx9t6ljn8q">
      <div className="mx-auto max-w-2xl" data-id="element-19" data-mp="pj6ds81asqsl">
        <h2 className="text-center font-display text-[1.25rem] font-bold uppercase text-white sm:text-[1.8rem]" data-id="element-20" data-mp="avcvugoqpc6u">
          5 PREMIUM <span className="text-gold" data-id="element-21" data-mp="ft4ojcx7l2c3">BONUSES INCLUDED</span>
        </h2>
        <div className="mt-2 space-y-2" data-id="element-22" data-mp="1un3jmyou3xv">
          {bonuses.map(bonus => <article key={bonus.number} className="rounded-md border-l-4 border-gold bg-white px-2.5 py-2 shadow-sm" data-id="element-23" data-mp="1wrh6wme2hbc">
              <h3 className="font-heading text-[0.7rem] font-extrabold uppercase leading-tight tracking-wide text-navy sm:text-[0.88rem]" data-id="element-24" data-mp="3o1v6kim4xyqq">
                🎁 BONUS {bonus.number} — {bonus.title}
              </h3>
              <p className="mt-0.5 text-[0.78rem] leading-[1.35] sm:text-[0.92rem]" data-id="element-25" data-mp="1m9yvfa3vqqwh">{bonus.body}</p>
            </article>)}
        </div>
      </div>
    </section>;
}